import React, { useEffect, useState } from "react";
import { NavHashLink } from "react-router-hash-link";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from "../components/About";
import Feedback from "../components/Feedback";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Menubar from "../components/Menubar";
import MyExpert from "../components/MyExpert";
import Projects from "../components/Projects";
import WorkTogether from "../components/WorkTogether";
import MainLogo from "../assets/image/mainLogo.gif";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Project from "../components/Project";

const Index = () => {
  const [topMenuBar, setTopMenuBar] = useState(false);

  let resizeWindow = () => {
    if (window.scrollY >= 500) {
      setTopMenuBar(true);
    } else {
      setTopMenuBar(false);
    }
  };
  useEffect(() => {
    resizeWindow();
    window.addEventListener("scroll", resizeWindow);

    return () => window.removeEventListener("resize", resizeWindow);
  }, []);
  return (
    <div>
      <Router>
        {topMenuBar && (
          <div className="tap_top">
            <NavHashLink className="tap_top_link" to={"#home"} smooth>
              <ArrowUpwardIcon />
            </NavHashLink>
          </div>
        )}

        <Menubar />
        <Header />
        <About />
        <MyExpert />
        <Projects />
        <Feedback />
        <WorkTogether />
        <Footer />
        {/* <Routes>
          <Route path="/project/:id" element={<Project />} />
        </Routes> */}
      </Router>
    </div>
  );
};

export default Index;
